import { CommonModule } from '@angular/common';
import { Component, ElementRef, inject, input, signal, viewChild } from '@angular/core';
import { openAbove } from '../../utils/dom';
import { AuthService } from '../../woo_services.module/AuthService';
import { GoogleTagManagerService } from '../../woo_services.module/GoogleTagManagerService';

@Component({
  selector: 'info-badge',
  templateUrl: './info-badge.component.html',
  styleUrls: ['./info-badge.component.scss'],
  imports: [CommonModule],
})
export class InfoBadge {
  private readonly googleTagManagerService = inject(GoogleTagManagerService);
  private readonly authService = inject(AuthService);

  readonly element = viewChild.required<ElementRef>('element');
  readonly gaName = input<string>('');

  protected readonly openUpwards = signal(false);

  mouseEnter(): void {
    this.openUpwards.set(openAbove(this.element()));
    this.trackOpenedInfoBadge(this.gaName());
  }

  private trackOpenedInfoBadge(name: string): void {
    this.googleTagManagerService.openedInfoBadge(this.authService.getFirstUserRole(), name);
  }
}
